<template>
  <div class="countryside">
    <div class="content1">
      <img :src="require('@/assets/xc1.jpg')" alt="" srcset="" />
      <div class="text">
        <div>赋能数字乡村</div>
        <div></div>
        <div>
          数字乡村，让科技与农业深度融合，助力乡村振兴，打造智慧、可持续的农业生态体系。
        </div>
      </div>
    </div>
    <div class="content2">
      <div class="title">赋能数字乡村解决方案</div>
      <div class="body">
        <div class="left">
          <div>
            数字乡村是伴随网络化、信息化和数字化在农业农村经济社会发展中的应用，以及农民现代信息技能的提高而衍生的农村现代化发展和转型进程。数字乡村建设既是乡村振兴的战略方向，也是建设数字中国的重要内容。
          </div>
          <div>
            数字乡村解决方案，积极响应国家政策要求，结合地域实际，以规划完善乡村机制体制为指引、以更好地服务乡村振兴工作为主旨、以乡村“五大振兴”为结果导向，重视乡村产业建设、紧抓乡村治理、强化民生服务，坚持可持续、可复制、可扩展的建设原则，致力解决乡村信息孤岛、提高乡村种植科技、加快乡村产业融合、改善乡村人居环境、强化乡村治理效能，打造具有时代性、先进性、地域特色的综合性数字乡村应用集群。
          </div>
        </div>
        <div class="right">
          <img :src="require('@/assets/xc2.jpg')" alt="" srcset="" />
        </div>
      </div>
      <div class="body-2">
        <div class="top">
          <img :src="require('@/assets/xc2.jpg')" alt="" srcset="" />
        </div>
        <div class="bottom">
          <div>
            数字乡村是伴随网络化、信息化和数字化在农业农村经济社会发展中的应用，以及农民现代信息技能的提高而衍生的农村现代化发展和转型进程。数字乡村建设既是乡村振兴的战略方向，也是建设数字中国的重要内容。
          </div>
          <div>
            数字乡村解决方案，积极响应国家政策要求，结合地域实际，以规划完善乡村机制体制为指引、以更好地服务乡村振兴工作为主旨、以乡村“五大振兴”为结果导向，重视乡村产业建设、紧抓乡村治理、强化民生服务，坚持可持续、可复制、可扩展的建设原则，致力解决乡村信息孤岛、提高乡村种植科技、加快乡村产业融合、改善乡村人居环境、强化乡村治理效能，打造具有时代性、先进性、地域特色的综合性数字乡村应用集群。
          </div>
        </div>
      </div>
    </div>
    <div class="content3">
      <div
        :class="
          index3 == 1 ? 'pitch' : index3 == 3 ? 'noPitch-right' : 'noPitch-left'
        "
      >
        <div>AI数字乡村代言人</div>
        <div>
          在数字化时代，AI数字乡村代言人成为连接城乡、传递信息的桥梁。数字代言人不仅仅是一种技术创新，更是乡村发展和文化传承的有力助手。
        </div>
      </div>
      <div
        :class="
          index3 == 2 ? 'pitch' : index3 == 1 ? 'noPitch-right' : 'noPitch-left'
        "
      >
        <div>数字政务</div>
        <div>
          数字政务是基于人工智能技术的新型农村治理模式。通过数字政务平台，乡村居民可以更便捷地办理各类证照、查询政策信息，实现政务服务的智能化和精准化。
        </div>
      </div>
      <div
        :class="
          index3 == 3 ? 'pitch' : index3 == 2 ? 'noPitch-right' : 'noPitch-left'
        "
      >
        <div>AI党政领导形象</div>
        <div>
          数字党政领导形象在推动农村数字化发展中扮演着关键角色。他们以数字化思维引领农村发展方向，通过政策支持和资源调配，推动数字科技在农村的广泛应用。
        </div>
      </div>
    </div>
    <div class="content4">
      <div>
        <img :src="require('@/assets/xc4.jpg')" alt="" srcset="" />
        <div class="text">
          <div>AI数字代言人</div>
          <div>
            沟通桥梁：数字代言人通过语音和图像技术，能够更直观、更亲近地与乡村居民交流，成为信息传递和反馈的重要平台。
          </div>
          <div>
            文化传承：AI数字代言人不仅了解当地的方言和文化，还能通过故事、歌谣等形式传承乡村的传统文化，促进乡村文化的传承与创新。
          </div>
        </div>
      </div>
      <div>
        <img :src="require('@/assets/xc5.jpg')" alt="" srcset="" />
        <div class="text">
          <div>数字政务</div>
          <div>
            在线证照：居民可以通过数字政务平台在线办理身份证、户口本等证照，减少农村居民因交通不便而耗费大量时间的问题。
          </div>
          <div>
            政策查询：数字政务平台整合各级政府发布的政策信息，使居民可以随时随地获取相关政策、法规和公告，提高政策透明度。
          </div>
        </div>
      </div>
      <div>
        <img :src="require('@/assets/xc6.jpg')" alt="" srcset="" />
        <div class="text">
          <div>AI党政领导形象</div>
          <div>
            数字党政领导形象通过数字平台与乡村居民保持更紧密的联系。他们定期通过数字媒体发布政策信息、听取民声，实时了解乡村发展的需求，形成良好的互动与反馈机制。
          </div>
        </div>
      </div>
    </div>

    <div class="content5">
      <div class="title">
        <div>案例展示</div>
        <div></div>
      </div>
      <div class="body">
        <div>
          <img :src="require('@/assets/al6.jpg')" alt="" srcset="" />
        </div>
        <div>
          <img :src="require('@/assets/al7.jpg')" alt="" srcset="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index3: 2,
    };
  },

  mounted() {
    setInterval(() => {
      this.index3++;
      if (this.index3 > 3) {
        this.index3 = 1;
      }
    }, 5000);
  },
};
</script>

<style lang="scss" scoped>
.countryside {
  min-height: 100vh;
  background-color: #f0f0f0;
  .content1 {
    width: 100%;
    // height: 100vh;
    overflow: hidden;
    position: relative;
    > img {
      // position: absolute;
      width: 100%;
    }
    @keyframes movedown {
      form {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    .text {
      left: 20vw;
      top: 20vw;
      opacity: 0;
      height: 100%;
      width: 100%;
      position: absolute;
      color: white;
      animation: movedown 1.5s;
      animation-fill-mode: forwards;
      > div:nth-child(1) {
        font-size: 40px;
        letter-spacing: 3px;
      }
      > div:nth-child(2) {
        height: 5px;
        width: 100px;
        background-color: white;
        margin: 30px 0px;
      }
      > div:nth-child(3) {
        font-size: 20px;
        width: 500px;
        letter-spacing: 2px;
        line-height: 1.5;
      }
    }
  }
  .content2 {
    // min-height: 100vh;
    // background-color: white;
    margin-bottom: 100px;
    .title {
      margin-left: 100px;
      font-size: 50px;
      margin-top: 50px;
      margin-bottom: 50px;
    }
    .body {
      display: flex;
      margin: 0px 100px;
      > .left {
        width: 60%;
        font-size: 20px;
        letter-spacing: 2px;
        line-height: 2;
        > div:nth-child(1) {
          margin-bottom: 50px;
        }
      }
      > .right {
        margin-left: 50px;
        width: 700px;
        > img {
          width: 100%;
        }
      }
    }
    .body-2 {
      display: none;
    }
  }
  .content3 {
    // width: 100%;
    height: 550px;
    background-image: url("../assets/xc3.jpg");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px 200px;
    > div {
      // flex: 1;
      background-color: white;
      margin: 0px 70px;
      overflow: hidden;
      overflow-y: auto;
      height: 460px;
      width: 260px;
      border-radius: 20px;
      padding: 20px;
      > div:nth-child(1) {
        text-align: center;
        font-size: 24px;
        margin-bottom: 20px;
        letter-spacing: 2px;
      }
      > div:nth-child(2) {
        font-size: 20px;
        letter-spacing: 2px;
        line-height: 2;
      }
    }
  }
  .content4 {
    padding-top: 50px;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    > div {
      display: flex;
      height: 35vw;
      max-height: 450px;
      width: 80%;
      background-color: #f0f0f0;
      margin-bottom: 50px;
      > img {
        height: 100%;
        width: 40%;
      }
      .text {
        margin: 20px;
        > div {
          font-size: 24px;
          margin-bottom: 20px;
          line-height: 1.5;
          letter-spacing: 2px;
        }
        > div:nth-child(1) {
          font-size: 30px;
        }
      }
    }
    > div:nth-child(even) {
      flex-direction: row-reverse;
    }
  }

  > .content5 {
    // min-height: 100vh;
    > .title {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      > div:nth-child(1) {
        font-size: 30px;
      }
      > div:nth-child(2) {
        margin-top: 20px;
        height: 5px;
        width: 100px;
        background-color: rgba(0, 102, 255, 0.8);
      }
    }
    > .body {
      display: flex;
      justify-content: center;
      padding: 50px 100px;
      > div {
        margin: 0px 100px;
        > img {
          width: 100%;
          height: 700px;
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .countryside {
    .content1 {
      .text {
        top: 50%;
        > div:nth-child(1) {
          font-size: 4vw !important;
        }
        > div:nth-child(2) {
          height: 1vw !important;
          margin: 2vw !important;
        }
        > div:nth-child(3) {
          font-size: 2vw;
          width: 50vw;
        }
      }
    }
    .content2 {
      margin-top: 6vw;
      .title{
        margin: 2vw !important;
        font-size: 5vw;
        text-align: center;
      }
      .body {
        display: none;
      }
      .body-2 {
        display: block;
        .top {
          display: flex;
          > img {
            margin: auto;
            width: 80%;
          }
        }
        .bottom {
          margin: 5vw;
          line-height: 1.5;
          > div {
            text-indent: 2em;
            font-size: 3vw;
          }
        }
      }
    }
    .content3 {
      perspective: 1000px;
      display: block;
      position: relative;
      > div {
        position: absolute;
        transform: translateZ(-100px);
        margin: 0px;
        width: 30vw;
        padding: 4vw;
        transition: all 0.6s ease-in-out;
        >div:nth-child(1){
          font-size: 5vw;
        }
        >div:nth-child(2){
          font-size: 4vw;
        }
      }
      .pitch {
        transform: translateZ(0px);
        z-index: 100;
        left: 30vw;
        opacity: 1;
      }
      .noPitch-left {
        opacity: 0.5;
        left: 10vw;
        transform: translateZ(-100px);
      }
      .noPitch-right {
        opacity: 0.5;
        left: 50vw;
        transform: translateZ(-100px);
      }
    }
    .content4 {
      > div {
        > .text {
          margin: 3vw;
          > div {
            font-size: 2vw;
            margin-bottom: 1vw !important;
          }
          > div:nth-child(1) {
            font-size: 2.5vw;
          }
        }
      }
    }
    .content5 {
      > .body {
        padding: 5vw;
        > div {
          margin: 0px 5vw;
          > img {
            width: 100%;
            height: 70vw;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/countryside.vue